// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Heading, TypoListItem, UnorderedList } from '@gandi/ui';

import styles from './CommercialArguments.scss';

export function CommercialArguments(): React.MixedElement {
  const { __ } = useTranslator();

  const items = [
    __('A free SSL certificate to secure your website'),
    __('2 free mailboxes using your domain name'),
    __(
      'Anycast and DNSSEC to ensure your services are secure and fast to access',
    ),
  ];

  return (
    <Base flex flexCol className={styles.infoContainer}>
      <Heading flexAlignSelfCenter fontSize="l" align="center">
        {__('Included services for each domain, free for the first year')}
      </Heading>
      <UnorderedList
        flex
        flexJustifyCenter
        icon="checkmark"
        iconTheme="success"
        marginBottom="base"
        size="base"
      >
        {items.map(item => (
          <TypoListItem key={item} weight="semibold">
            {item}
          </TypoListItem>
        ))}
      </UnorderedList>
    </Base>
  );
}
